import React from "react";
import { Box, Container, Typography, Paper, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { Localization } from "../../assets/Localization/Localization";

const PrivacyPolicy = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const content = Localization.en.PrivacyPolicy;

  return (
    <Box
      sx={{
        padding: { xs: "50px 20px", sm: "80px 40px" },
        backgroundColor: theme.palette.background.default,
        minHeight: "100vh",
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={6}
          sx={{
            padding: "40px",
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: "10px",
            boxShadow: theme.shadows[4],
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              marginBottom: "20px",
              textAlign: "center",
              color: theme.palette.text.primary,
            }}
          >
            Privacy Policy
          </Typography>

          <Typography
            variant="subtitle2"
            sx={{ marginBottom: "20px", textAlign: "center" }}
          >
            {content.effectiveDate}
          </Typography>

          <Typography
            variant="body1"
            sx={{ marginBottom: "20px", color: theme.palette.text.secondary }}
          >
            {content.intro}
          </Typography>

          {content.sections.map((section, index) => (
            <Box key={index} sx={{ marginBottom: "20px" }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  marginBottom: "10px",
                  color: theme.palette.text.primary,
                }}
              >
                {section.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: theme.palette.text.secondary }}
              >
                {section.content.split("\n").map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </Typography>
            </Box>
          ))}

          <Box textAlign="center" sx={{ marginTop: "30px" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/")}
              sx={{ padding: "10px 20px" }}
            >
              {content.backToHome}
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PrivacyPolicy;
